/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/** @module MatchModule */

import {
    IIPReputationTypeMatch,
    IPReputationType,
    MatchOperation,
} from 'generated-types';

import { MessageItem } from 'ajs/modules/data-model/factories/message-item.factory';

/**
 * Token for IPReputationTypeMatchConfigItem class.
 */
export const IP_REPUTATION_TYPE_MATCH_CONFIG_ITEM_TOKEN = 'IPReputationTypeMatchConfigItem';

/**
 * @description  IPReputationTypeMatch ConfigItem class.
 * @author Sarthak Kapoor
 */
export class IPReputationTypeMatchConfigItem extends MessageItem<IIPReputationTypeMatch> {
    constructor(args = {}) {
        const extendedArgs = {
            objectType: 'IPReputationTypeMatch',
            ...args,
        };

        super(extendedArgs);
    }

    /** @override */
    // eslint-disable-next-line no-underscore-dangle
    public get defaultConfigOverride_(): Partial<IIPReputationTypeMatch> {
        return {
            match_operation: MatchOperation.IS_IN,
        };
    }

    /**
     * Getter for selected ip reputation types.
     */
    public get reputationTypes(): IPReputationType[] {
        return this.config.reputation_types;
    }
}
